//import { AjaxError, AjaxResponse } from 'rxjs/ajax';
// export interface actionType<T = any> {
//     type: string;
//     payload?: T;
//     meta?: any;
// }
// declare const CreateAsyncAction: <T extends unknown = any>(actionName: any) => {
//     name: string;
//     success: string;
//     failure: string;
//     progress: string;
//     cancel: string;
//     clear: string;
//     action: {
//         (payload: T, meta?: any): actionType<T>;
//         (payload: T, meta: any): actionType<T>;
//         (payload?: T | undefined, meta?: any): actionType<T>;
//     };
//     reload: string;
//     //successAction: (payload: AjaxResponse, meta?: any) => {
//     successAction: (payload: any, meta?: any) => {
//         type: string;
//         payload: any;
//         meta: any;
//     };
//     failureAction: (payload: AjaxError, meta?: any) => {
//         type: string;
//         payload: AjaxError;
//         meta: any;
//     };
//     cancelAction: (payload?: Partial<T> | undefined, meta?: any) => {
//         type: string;
//         payload: Partial<T> | undefined;
//         meta: any;
//     };
//     clearAction: (payload?: Partial<T> | undefined, meta?: any) => {
//         type: string;
//         payload: Partial<T> | undefined;
//         meta: any;
//     };
//     progressAction: (payload?: any, meta?: any) => {
//         type: string;
//         payload: any;
//         meta: any;
//     };
//     reloadAction: (payload?: Partial<T> | undefined, meta?: any) => {
//         type: string;
//         payload: Partial<T> | undefined;
//         meta: any;
//     };
// };
// export default CreateAsyncAction;


/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable class-methods-use-this */
import { nanoid } from 'nanoid';
import { AjaxError } from 'rxjs/ajax';

interface ActionType<T = any> {
	type: string;
	payload?: T;
	meta?: any;
}

/** It is at the SDK level, you can use CreateAction from SDK */
const CreateAsyncAction = <T extends any = any>(actionName: string) => {
	const id = nanoid(6);
	const name = `${id}/${actionName}`;
	const success = `${id}/${actionName}_SUCCESS`;
	const cancel = `${id}/${actionName}_CANCEL`;
	const clear = `${id}/${actionName}_CLEAR`;
	const progress = `${id}/${actionName}_PROGRESS`;
	const failure = `${id}/${actionName}_FAILURE`;
	function action(payload: T, meta?: any): ActionType<T>;
	function action(payload: T, meta: any): ActionType<T>;
	function action(payload?: T, meta?: any): ActionType<T>;
	function action(payload?: T, meta?: any) {
		return {
			type: name,
			payload,
			meta
		};
	}
	return {
		name,
		success,
		failure,
		progress,
		cancel,
		clear,
		action,
		successAction: (payload: any, meta?: any) => ({
			type: success,
			payload,
			meta
		}),
		failureAction: (payload: AjaxError, meta?: any) => ({
			type: failure,
			payload,
			meta
		}),
		cancelAction: (payload?: Partial<T>, meta?: any) => ({
			type: cancel,
			payload,
			meta
		}),
		clearAction: (payload?: Partial<T>, meta?: any) => ({
			type: clear,
			payload,
			meta
		}),
		progressAction: (payload: any, meta?: any) => ({
			type: progress,
			payload,
			meta
		})
	};
};

export default CreateAsyncAction;

